import { render, staticRenderFns } from "./videoData.vue?vue&type=template&id=109cb4ac"
import script from "./videoData.vue?vue&type=script&lang=js"
export * from "./videoData.vue?vue&type=script&lang=js"
import style0 from "./videoData.vue?vue&type=style&index=0&id=109cb4ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports